import { Language } from "../types/weather.types";

const languages: Language[] = [
    { name: 'en', label: 'English', iconUrl: '/flags/en.png' },
    { name: 'ka', label: 'ქართული', iconUrl: '/flags/ge.png' }
]

export { languages };